"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const web3_1 = __importDefault(require("web3"));
const erc721_abi_1 = require("../../abi/erc721.abi");
const messageHelper_1 = require("../helpers/messageHelper");
const required_1 = require("../../helpers/required/required");
const web3Factory_1 = require("../helpers/web3Factory");
const lodash_1 = require("lodash");
const sumBN_1 = require("../helpers/sumBN/sumBN");
const abbreviateHelper_1 = require("../../helpers/abbreviateNumberHelper/abbreviateHelper");
const getSymbolAndName_1 = require("../helpers/getSymbolAndName");
const getBalancesOfFromChain = (token, addresses) => __awaiter(void 0, void 0, void 0, function* () {
    const { address: ERC71Address, chainId } = token;
    required_1.requiredDefined(ERC71Address, 'address of token is required');
    required_1.requiredDefined(chainId, 'chainId of token is required');
    const web3Provider = yield web3Factory_1.web3Factory(chainId);
    const erc721SmartContracts = new web3Provider.eth.Contract(erc721_abi_1.erc721ABI, ERC71Address);
    return yield Promise.all(addresses.map(address => erc721SmartContracts.methods.balanceOf(address).call()
        .then(balanceOf => ({
        address,
        balanceOf,
        chainId
    }))));
});
const getBalances = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { addresses, params } = strategy;
    const balances = yield Promise.all(params.tokens
        .map(param => getBalancesOfFromChain(param, addresses)));
    const flatBalances = lodash_1.flattenDeep(balances);
    const minBalanceAbbreviated = abbreviateHelper_1.abbreviateTokenBN(params.minBalance, 0);
    return {
        sum: sumBN_1.sumBN(flatBalances.map(d => d.balanceOf)),
        balances: flatBalances,
        minBalance: minBalanceAbbreviated.abbreviated,
        minBalanceWithDecimals: minBalanceAbbreviated.abbreviated
    };
});
exports.strategy = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { params } = strategy;
    const balances = yield getBalances(strategy);
    const firstToken = params.tokens[0];
    const { symbol, name } = yield getSymbolAndName_1.getNameAndSymbolERC721({
        address: firstToken.address,
        chainId: firstToken.chainId,
        default: {
            name: params.name,
            symbol: params.symbol
        }
    });
    const amount = web3_1.default.utils.toBN(balances.sum);
    const minAmount = web3_1.default.utils.toBN(params.minBalance);
    const isAuthorized = amount.gte(minAmount);
    const message = messageHelper_1.minMaxMessage({
        symbol,
        name,
        decimals: 0,
        balance: balances.sum,
        amountRequired: params.minBalance
    });
    const code = isAuthorized ? 0 /* SUCCESS */ : 1 /* NOTENOUGH */;
    const enrichedInformations = {
        symbol: symbol,
        name: name,
        logo: strategy.logo,
        acquireURLs: strategy.acquireURLs
    };
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code,
        enrichedInformations,
        details: balances
    };
});
/*
export const strategy = (web3Provider: web3) =>
  async (strategy: Strategy): StrategyReturnPromise => {
    const { address, params } = strategy;

    assert(params.address !== undefined, 'erc20 address is required');
    assert(params.minBalance !== undefined, 'minBalance is required');

    const erc20Address = params.address;
    const erc20SmartContracts = new web3Provider.eth.Contract(erc721ABI as any, erc20Address);

    const [balanceOf, symbol] = await Promise.all([
      erc20SmartContracts.methods.balanceOf(address).call(),
      erc20SmartContracts.methods.symbol().call()
    ]);

    const amount = web3Provider.utils.toBN(balanceOf);
    const minAmount = web3Provider.utils.toBN(params.minBalance);

    const isAuthorized = amount.gte(minAmount);

    const message = minMaxMessage({
      symbol,
      decimals: 0,
      balance: balanceOf,
      amountRequired: minAmount
    });

    const code = isAuthorized ? ErrorCode.SUCESS : ErrorCode.NOTENOUGH;

    return {
      isAuthorized,
      strategy: strategy,
      message: message,
      code
    };
  };
*/
//# sourceMappingURL=index.js.map